import classNames from 'classnames';
import * as styles from '../Pricing.css';

interface Props {
  isDisabled: boolean;
  ctaText: string;
}

const StripeCheckoutButton = ({ isDisabled, ctaText }: Props) => {
  return (
    <input
      type="submit"
      value={ctaText}
      className={classNames(styles.inputSubmit, 'py-2 px-4', isDisabled && 'animate-pulse')}
      disabled={isDisabled}
    />
  );
};

export default StripeCheckoutButton;
